var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgConfigColumns = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 32 32"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "config-columns_svg__a",
  width: "101.2%",
  height: "135%",
  x: "-.6%",
  y: "-12.5%",
  filterUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("feOffset", {
  dy: 2,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1",
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "shadowBlurOuter1",
  values: "0 0 0 0 0.791219076 0 0 0 0 0.791219076 0 0 0 0 0.791219076 0 0 0 0.5 0"
})), /*#__PURE__*/React.createElement("path", {
  id: "config-columns_svg__b",
  d: "M0 0h1160v40H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M-1384-270H56V780h-1440z"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-1124 -4)"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#config-columns_svg__b",
  fill: "#000",
  filter: "url(#config-columns_svg__a)"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#config-columns_svg__b",
  fill: "#F0F1F4"
})), /*#__PURE__*/React.createElement("g", {
  fill: "#000"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "nonzero",
  d: "M11.645 25H6.25A2.25 2.25 0 0 1 4 22.75V6.25A2.25 2.25 0 0 1 6.25 4h14.5C21.99 4 23 5.009 23 6.25v3.382a.75.75 0 0 1-1.5 0V6.25a.75.75 0 0 0-.75-.75H6.25a.75.75 0 0 0-.75.75v16.5c0 .414.336.75.75.75h4.385z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "nonzero",
  d: "M22.994 10.5H4.75a.75.75 0 0 1 0-1.5h18.244zm-11.669 5H4.75a.75.75 0 0 1 0-1.5h7.588zm.845 5H4.75a.75.75 0 0 1 0-1.5h7.451c-.08.588-.083.814-.031 1.5"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "nonzero",
  d: "m13.605 12.125-.855 1.277V9.75a.75.75 0 0 1 1.5 0v2.84z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.367 28h-4.758v-1.931a6.3 6.3 0 0 1-1.527-.946l-1.342 1.012L12 22.041l1.762-1.293a6.7 6.7 0 0 1 .034-1.749l-1.638-1.206L14.89 13.7l1.376 1.013c.405-.32.847-.587 1.315-.795V12h4.786v1.909c.493.214.959.492 1.386.828l1.388-1.018 2.72 4.074-1.657 1.217a6.7 6.7 0 0 1 .036 1.713L28 22.017l-2.74 4.093-1.315-.979c-.479.4-1.01.726-1.578.966zm-3.18-1.655h1.603v-1.446l.56-.176a4.7 4.7 0 0 0 1.962-1.23l.468-.492 1.094.803.923-1.38-1.288-.945.1-.527a5 5 0 0 0-.05-2.108l-.13-.552 1.229-.902-.923-1.379-1.105.811-.473-.455a4.7 4.7 0 0 0-1.842-1.104l-.526-.165v-1.443h-1.62v1.465l-.555.18a4.6 4.6 0 0 0-1.77 1.061l-.473.447-1.105-.802-.923 1.379 1.213.89-.13.553c-.17.7-.186 1.432-.05 2.14l.1.53-1.293.949.923 1.38 1.107-.828.468.485c.542.563 1.206.98 1.936 1.217l.557.179zM20 19.04c.37 0 .704.234.846.593a1 1 0 0 1-.199 1.046.88.88 0 0 1-.997.208.96.96 0 0 1-.565-.887 1 1 0 0 1 .126-.502l.053-.05A.9.9 0 0 1 20 19.04m0-1.655c-.795 0-1.541.4-2.01 1.073l-.08.121a2.71 2.71 0 0 0 .267 3.192c.773.875 2.013 1.089 3.013.52 1-.57 1.505-1.777 1.228-2.934-.278-1.157-1.268-1.97-2.405-1.975z"
})))));
export { SvgConfigColumns as ReactComponent };
export default __webpack_public_path__ + "static/media/config-columns.2d6fdeb4.svg";